import React, { useContext, useEffect, useState } from 'react';
import { FormControl, Button, Card, Typography, Grid, Box, FormGroup, FormControlLabel, Checkbox, Divider, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Modal } from '@mui/material';
import dayjs from 'dayjs';
import { BookingService } from '../Service';
import { BookingDataContext, StepperDataContext } from './AddBooking';
import Swal from 'sweetalert2';
import ApplyDiscount from './ApplyDiscount';
import { Calculate, Close } from '@mui/icons-material';
import CouponAmountCalculator from '../viewDetails/CouponAmountCalculator';

export default function BookingReview() {
  const { dateTimeSlot, bookingInProgressData, setBookingInProgressData } = useContext(BookingDataContext);
  const { handleNext, handleBack, handleComplete, } = useContext(StepperDataContext);


  const proceedForPayment = (data) => {
    // handleComplete();
    handleNext();
  }

  const modifyTime = (time) => {
    const timeJson = JSON.parse(time);
    return `${dayjs(timeJson.startTime, 'HH:mm:ss').format('h:mm A')} - ${dayjs(timeJson.endTime, 'HH:mm:ss').format('h:mm A')}`
  };

  const [useCoins, setUseCoins] = useState(false);

  const [coinDetails, setCoinDetails] = useState({
    coinValue: 0,
    totalAvailableCoins: 0,
  });

  useEffect(() => {
    if (bookingInProgressData) {
      setCoinDetails(pre => ({
        ...pre,
        coinValue: bookingInProgressData?.coinValue,
        totalAvailableCoins: bookingInProgressData?.customer?.totalCoin
      }));

      // Set checkbox checked if coinValue > 0
      if (bookingInProgressData?.coinValue > 0) {
        setUseCoins(true);
      }
    }
  }, [bookingInProgressData]);

  const handleCoinsChange = async (e) => {
    Swal.fire({
      // title: ``,
      text: `${!useCoins ? 'Please wait while coin is used in booking...' : 'Please wait removing coins used in booking...'}`,
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    // Toggle the state
    const newUseCoinsValue = !useCoins;
    setUseCoins(newUseCoinsValue);
    try {

      const timeSlotUpdateResponse = await BookingService.updatebookingTimeSlot({
        "bookingId": bookingInProgressData?.id,
        "timeSlotDate": bookingInProgressData?.serviceDate,
        "startTime": bookingInProgressData.bookingStartTime,
        "endTime": bookingInProgressData.bookingEndTime,
        "useCoin": newUseCoinsValue,
        "couponCode":bookingInProgressData?.couponId == null ? '' : bookingInProgressData?.couponDetails.couponCode
      });

      if (timeSlotUpdateResponse.success == "1") {
        // setBookingInProgressData(timeSlotUpdateResponse.data);
        const bookingDetails = await BookingService.bookingDetailById(bookingInProgressData?.id)
        setBookingInProgressData(bookingDetails.data);
        Swal.close();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Something Went wrong. Please try again.',
      });
      console.error("Error in using coin:", error);
    }

  };
  const removeCoupon = async (e) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: `You are about to remove the coupon code`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Remove it!',
      cancelButtonText: 'No, cancel!',
      allowOutsideClick: false,
    });
    if (result.isConfirmed) {
      Swal.fire({
        // title: ``,
        text: `${'Please wait while removing Coupon...' }`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      // Toggle the state
      
      try {

        const timeSlotUpdateResponse = await BookingService.updatebookingTimeSlot({
          bookingId: bookingInProgressData?.id,
          timeSlotDate: bookingInProgressData?.serviceDate,
          startTime: bookingInProgressData.bookingStartTime,
          endTime: bookingInProgressData.bookingEndTime,
          useCoin: bookingInProgressData?.coinValue == '0'?false:true,
          couponCode: '' ,
        });

        if (timeSlotUpdateResponse.success == "1") {
          // setBookingInProgressData(timeSlotUpdateResponse.data);
          const bookingDetails = await BookingService.bookingDetailById(bookingInProgressData?.id)
          setBookingInProgressData(bookingDetails.data);
          Swal.close();
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Something Went wrong. Please try again.',
        });
        console.error("Error in removing coin:", error);
      }
    }
  };
  const [openDiscountModal, setOpenDiscountModal] = useState(false);
  return (
    <Box sx={{ overflow: "auto", backgroundColor: "#fff", padding: { xs: '2%', md: '1% 3%' } }}>
      <Grid container spacing={2} >
        <Grid item xs={12} md={6} sx={{ mb: '1%' }}>
          <Box>
            <Typography sx={{ fontWeight: '600', color: '#494949', fontSize: { xs: '.85rem' } }}>Customer Details</Typography>
            <Card sx={{ p: '1%', bgcolor: '#dadada4d' }}>
              <Grid container spacing={{ xs: 0, md: 1 }}>
                <Grid item xs={12} md={5}>
                  <Box sx={{ display: "flex" }}>
                    <Typography sx={{ fontWeight: 500, color: '#3E3E3E', width: { xs: '30%', md: '30%' }, fontSize: '.75rem' }} variant='body1'>Name </Typography>
                    <Typography sx={{ fontWeight: 500, color: '#6E6E6E', fontSize: '0.75rem', width: '2%' }}>: </Typography>
                    <Typography sx={{ fontWeight: 500, color: '#3E3E3E', fontSize: '0.75rem', width: '78%' }} >{bookingInProgressData?.customerName}</Typography>
                  </Box>
                  <Box sx={{ display: "flex" }}>
                    <Typography sx={{ fontWeight: 500, color: '#3E3E3E', width: { xs: '30%', md: '30%' }, fontSize: '.75rem' }} variant='body1'>Contact </Typography>
                    <Typography sx={{ fontWeight: 500, color: '#6E6E6E', fontSize: '0.75rem', width: '2%' }}>: </Typography>
                    <Typography sx={{ fontWeight: 500, color: '#3E3E3E', fontSize: '0.75rem', width: '78%' }} >{bookingInProgressData?.customer?.mobileNumber || ''}</Typography>
                  </Box>
                  {/* <Box>
                    <Typography sx={{ fontWeight: 500, color: '#3E3E3E' }} variant='body1'> <Box component={'span'} sx={{ fontWeight: 600, color: '#6E6E6E', fontSize: '0.75rem' }}>: {}</Box></Typography>
                    <Typography sx={{ fontWeight: 500, color: '#3E3E3E' }} variant='body1'> <Box component={'span'} sx={{ fontWeight: 600 }}></Box>: {}</Typography>
                  </Box> */}
                </Grid>
                <Grid item xs={12} md={7}>
                  <Box sx={{ display: "flex" }}>
                    <Typography sx={{ fontWeight: 500, color: '#3E3E3E', width: { xs: '30%', md: '20%' }, fontSize: '.75rem' }} variant='body1'>Address </Typography>
                    <Typography sx={{ fontWeight: 500, color: '#6E6E6E', fontSize: '0.75rem', width: '2%' }}>: </Typography>
                    <Typography sx={{ fontWeight: 500, color: '#3E3E3E', fontSize: '0.75rem', width: '78%' }} >{bookingInProgressData?.customer?.defaultAddressDetail?.address || bookingInProgressData?.add_address}</Typography>
                  </Box>
                  <Box sx={{ display: "flex" }}>
                    <Typography sx={{ fontWeight: 500, color: '#3E3E3E', width: { xs: '30%', md: '20%' }, fontSize: '.75rem' }} variant='body1'>Landmark </Typography>
                    <Typography sx={{ fontWeight: 500, color: '#6E6E6E', fontSize: '0.75rem', width: '2%' }}>: </Typography>
                    <Typography sx={{ fontWeight: 500, color: '#3E3E3E', fontSize: '0.75rem', width: '78%' }} >{bookingInProgressData?.add_landmark || ''}</Typography>
                  </Box>
                </Grid>
              </Grid>
            </Card>
          </Box>
        </Grid>
        <Grid item xs={12} md={6} sx={{ mb: '1%' }}>
          <Box>
            <Typography sx={{ fontWeight: '600', color: '#494949', fontSize: { xs: '.85rem' } }}>Service Expert</Typography>
            <Card sx={{ p: '1%', bgcolor: '#dadada4d' }}>
              <Grid container spacing={{ xs: 0, md: 1 }}>
                <Grid item xs={12} md={5}>
                  <Box sx={{ display: "flex" }}>
                    <Typography sx={{ fontWeight: 500, color: '#3E3E3E', width: { xs: '30%', md: '30%' }, fontSize: '.75rem' }} variant='body1'>Name </Typography>
                    <Typography sx={{ fontWeight: 500, color: '#6E6E6E', fontSize: '0.75rem', width: '2%' }}>: </Typography>
                    <Typography sx={{ fontWeight: 500, color: '#3E3E3E', fontSize: '0.75rem', width: '78%' }} >{bookingInProgressData?.providerName}</Typography>
                  </Box>
                  <Box sx={{ display: "flex" }}>
                    <Typography sx={{ fontWeight: 500, color: '#3E3E3E', width: { xs: '30%', md: '30%' }, fontSize: '.75rem' }} variant='body1'>Contact </Typography>
                    <Typography sx={{ fontWeight: 500, color: '#6E6E6E', fontSize: '0.75rem', width: '2%' }}>: </Typography>
                    <Typography sx={{ fontWeight: 500, color: '#3E3E3E', fontSize: '0.75rem', width: '78%' }} >{bookingInProgressData?.provider?.mobileNumber || ''}</Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={7}>
                  <Box sx={{ display: "flex" }}>
                    <Typography sx={{ fontWeight: 500, color: '#3E3E3E', width: { xs: '30%', md: '20%' }, fontSize: '.75rem' }} variant='body1'>Address </Typography>
                    <Typography sx={{ fontWeight: 500, color: '#6E6E6E', fontSize: '0.75rem', width: '2%' }}>: </Typography>
                    <Typography sx={{ fontWeight: 500, color: '#3E3E3E', fontSize: '0.75rem', width: '78%' }} >{bookingInProgressData?.provider?.UserAddress?.address}</Typography>
                  </Box>
                  {/* <Box sx={{ display: "flex" }}>
                    <Typography sx={{ fontWeight: 500, color: '#3E3E3E', width: {xs:'30%',md:'20%'},fontSize:'.75rem' }} variant='body1'>waiveVisitCharge </Typography>
                    <Typography sx={{ fontWeight: 500, color: '#6E6E6E', fontSize: '0.75rem', width: '2%' }}>: </Typography>
                    <Typography sx={{ fontWeight: 500, color: '#3E3E3E', fontSize: '0.75rem', width: '78%' }} >{bookingInProgressData?.provider?.UserProfile?.waiveVisitCharge}</Typography>
                  </Box> */}
                </Grid>
              </Grid>
            </Card>
          </Box>
        </Grid>
        <Grid item xs={12} md={6} sx={{ mb: '1%' }}>
          <Box>
            <Typography sx={{ fontWeight: '600', color: '#494949', fontSize: { xs: '.85rem' } }}>Schedule Details</Typography>
            <Card sx={{ p: '1%', bgcolor: '#dadada4d' }}>
              <Grid container spacing={{ xs: 0, md: 1 }}>
                <Grid item xs={12} md={5}>
                  <Box sx={{ display: "flex" }}>
                    <Typography sx={{ fontWeight: 500, color: '#3E3E3E', width: { xs: '30%', md: '30%' }, fontSize: '.75rem' }} variant='body1'>Date </Typography>
                    <Typography sx={{ fontWeight: 500, color: '#6E6E6E', fontSize: '0.75rem', width: '2%' }}>: </Typography>
                    <Typography sx={{ fontWeight: 500, color: '#3E3E3E', fontSize: '0.75rem', width: '78%' }} >{bookingInProgressData?.serviceDate || ''}</Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={7}>
                  <Box sx={{ display: "flex" }}>
                    <Typography sx={{ fontWeight: 500, color: '#3E3E3E', width: { xs: '30%', md: '20%' }, fontSize: '.75rem' }} variant='body1'>Slot Timing </Typography>
                    <Typography sx={{ fontWeight: 500, color: '#6E6E6E', fontSize: '0.75rem', width: '2%' }}>: </Typography>
                    <Typography sx={{ fontWeight: 500, color: '#3E3E3E', fontSize: '0.75rem', width: '78%' }} >{modifyTime(dateTimeSlot?.timeSlot) || ''}</Typography>
                  </Box>
                </Grid>
              </Grid>
            </Card>
          </Box>
        </Grid>
        <Grid item xs={12} sx={{ mb: '1%' }}>
          <Box>
            <Typography sx={{ fontWeight: '600', color: '#494949', fontSize: { xs: '.85rem' } }}>Service Details</Typography>
            <Card sx={{ bgcolor: '#dadada4d' }}>
              <Grid container>
                <Grid item xs={12} md={9}>
                  <Box>
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ fontWeight: 600, color: '#6E6E6E', p: '1%', fontSize: '.75rem' }} width="40%" >Service</TableCell>
                            <TableCell sx={{ fontWeight: 600, color: '#6E6E6E', p: '1%', fontSize: '.75rem' }} width="15%" >Quantity</TableCell>
                            <TableCell sx={{ fontWeight: 600, color: '#6E6E6E', p: '1%', fontSize: '.75rem' }} width="15%" >Time</TableCell>
                            <TableCell sx={{ fontWeight: 600, color: '#6E6E6E', p: '1%', fontSize: '.75rem' }} width="15%" >Price</TableCell>
                            <TableCell sx={{ fontWeight: 600, color: '#6E6E6E', p: '1%', fontSize: '.75rem' }} width="15%" >Total </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {bookingInProgressData?.bookingItems.map((service) => (
                            <TableRow key={service?.id} sx={{ borderBottom: 'none' }}>
                              <TableCell sx={{ p: '1%', color: '#494949', borderBottom: 'none', fontSize: '0.75rem' }}>{service?.serviceName}{service?.providerServices?.brd.id != '1' && <Box component={'span'} sx={{color:'#1976d2'}}>{`_${service?.providerServices?.brd.title}`}</Box>}</TableCell>
                              <TableCell sx={{ p: '1% 3%', color: '#494949', borderBottom: 'none', fontSize: '0.75rem' }}>{service?.quantity}</TableCell>
                              <TableCell sx={{ p: '1%', color: '#494949', borderBottom: 'none', fontSize: '0.75rem' }}>{service?.serviceTime}mins</TableCell>
                              <TableCell sx={{ p: '1%', color: '#494949', borderBottom: 'none', fontSize: '0.75rem' }}>{service?.price}</TableCell>
                              <TableCell sx={{ p: '1%', color: '#494949', borderBottom: 'none', fontSize: '0.75rem' }}>{parseFloat(service?.price * service?.quantity).toFixed(2)}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                </Grid>
                <Grid item xs={12} md={3} sx={{ borderTop: { md: 'none', xs: '1px solid #BEC2C2' }, borderLeft: { sm: 'none', md: '1px solid #BEC2C2' }, display: { sm: 'flex', md: 'block' }, justifyContent: 'end', pr: { sm: '5%', md: '0%' } }}>
                  <Box sx={{ p: '4%', borderBottom: '1px solid #BEC2C2', display: { sm: 'none', md: 'block' } }}>
                    <Typography sx={{ fontWeight: 600, fontSize: '0.75rem' }}>Payment Summary</Typography>
                  </Box>
                  <Box sx={{ minWidth: { xs: '14rem', md: '0rem' } }}>
                    <Box sx={{ px: 1, display: 'flex', justifyContent: 'space-between', mb: .5 }}>
                      <Typography sx={{ fontSize: '0.75rem' }} color="text.secondary">
                        Subtotal
                      </Typography>
                      <Typography sx={{ fontSize: '0.75rem' }}>
                        ₹ {parseFloat(bookingInProgressData?.subTotal).toFixed(2)}
                      </Typography>
                    </Box>
                    <Box sx={{ px: 1, display: 'flex', justifyContent: 'space-between', mb: .5 }}>
                      <Typography sx={{ fontSize: '0.75rem' }} color="text.secondary">
                        Platform Fee
                      </Typography>
                      <Typography sx={{ fontSize: '0.75rem' }}>
                        ₹ {parseFloat(bookingInProgressData?.platformCharges).toFixed(2)}
                      </Typography>
                    </Box>
                    <Box sx={{ px: 1, display: 'flex', justifyContent: 'space-between', mb: .5 }}>
                      <Typography sx={{ fontSize: '0.75rem' }} color="text.secondary">
                        Convenience Fee
                      </Typography>
                      <Typography sx={{ fontSize: '0.75rem' }}>
                        ₹ {parseFloat(bookingInProgressData?.convenienceFee).toFixed(2)}
                      </Typography>
                    </Box>
                    <Box sx={{ px: 1, display: 'flex', justifyContent: 'space-between', mb: .5 }}>
                      <Typography sx={{ fontSize: '0.75rem' }} color="text.secondary">
                        Discount
                      </Typography>
                      <Box>
                        <Typography sx={{ fontSize: '0.75rem', color: '#d32f2f',textAlign:'right' }}>
                          ₹ {(parseFloat(bookingInProgressData?.couponAmount || 0)).toFixed(2)}
                        </Typography>
                        {bookingInProgressData?.couponDetails && <Box sx={{}}>
                          <Box sx={{display:'flex',alignItems:'center',justifyContent:'end'}}>
                          <Typography sx={{fontSize: '0.55rem',border:'1px dashed red',p:'.6% 2%',fontWeight:600,bgcolor:'#3a2bde',color:'#fff'}}>
                              {bookingInProgressData?.couponDetails.couponCode}
                          </Typography>
                          <IconButton sx={{p:0}} size='small' color='error' onClick={()=>removeCoupon()}><Close sx={{fontSize:'1rem'}}/></IconButton>
                          </Box>
                        </Box>}
                      </Box>
                    </Box>
                    <Box sx={{ px: 1, display: bookingInProgressData?.coinValue > 0 ? 'flex' : 'none', justifyContent: 'space-between', mb: .5 }}>
                      <Typography sx={{ fontSize: '0.75rem' }} color="text.secondary">
                        Cudel Coins Used
                      </Typography>
                      <Typography sx={{ fontSize: '0.75rem', color: '#d32f2f' }}>
                        ₹  {parseFloat(bookingInProgressData?.coinValue).toFixed(2)}

                      </Typography>
                    </Box>
                    <Box sx={{ px: 1, display: 'flex', justifyContent: 'space-between', mb: .5 }}>
                      <Typography sx={{ fontSize: '0.75rem' }} color="text.secondary">
                        Visiting Charge
                      </Typography>
                      <Typography sx={{ fontSize: '0.75rem' }}>
                        ₹ {parseFloat(bookingInProgressData?.visitingCharge).toFixed(2)}
                      </Typography>
                    </Box>
                    <Box sx={{ px: 1, display: 'flex', justifyContent: 'space-between', mb: .5 }}>
                      <Typography sx={{ fontSize: '0.75rem' }} color="text.secondary">
                        Tax
                      </Typography>
                      <Typography sx={{ fontSize: '0.75rem' }}>
                        ₹ {parseFloat(bookingInProgressData?.tax).toFixed(2)}
                      </Typography>
                    </Box>



                    <Divider sx={{ my: .5 }} />

                    <Box sx={{ p: 1, display: 'flex', justifyContent: 'space-between' }}>
                      <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: '#3e3e3e' }}>
                        Total Amount
                      </Typography>
                      <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: '#3e3e3e' }}>

                        ₹ {parseFloat(bookingInProgressData?.total).toFixed(2)}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Card>
          </Box>
        </Grid>
        {bookingInProgressData?.customer?.totalCoin > 0 ?
          <Grid item xs={12} sm={6} sx={{ mb: '1%',paddingTop:{sm:'auto',xs:'0px!important'} }}>
            <FormControl sx={{ minWidth: "100%" }} component="fieldset" >
              <FormGroup>
                <FormControlLabel
                  sx={{
                    '& .MuiTypography-root': { fontSize: '0.65rem' }, // Controls label size
                    '& .MuiCheckbox-root': { transform: 'scale(.65)' }, // Controls checkbox size
                  }}
                  control={
                    <Checkbox
                      checked={useCoins}
                      onChange={handleCoinsChange}
                    // sx={{
                    //   transform: 'scale(1.2)', // Adjusts checkbox size
                    // }}
                    />
                  }
                  label={`Save ₹ ${coinDetails?.coinValue} with ${coinDetails?.coinValue} Cudel Coins (Balance: ${bookingInProgressData?.customer?.totalCoin})`}
                />
              </FormGroup>
            </FormControl>
          </Grid>
          :
          <Grid item xs={12} sm={6} sx={{ mb: '1%' }}></Grid>
        }
        
          <Grid item xs={12} sm={6} sx={{ mb: '1%',display:'flex',paddingTop:{sm:'auto',xs:'0px!important'}, justifyContent: { xs: 'left', sm: 'right' }}}>
          {!bookingInProgressData.couponDetails && 

            <Button sx={{ textTransform: 'none',height:'fit-content' }} size='small' variant="outlined" color="secondary" onClick={() => setOpenDiscountModal(true)}>
              Apply Coupon Discount
            </Button>
            }
            <CouponAmountCalculator 
              bookingDetailsdata={{
                id: bookingInProgressData?.id,
                customer:{
                  id: bookingInProgressData?.customerId,
                }
              }} 
              label={'icon'} 
            />         
          </Grid>
        

        {/* submit button section */}
        <Grid container>
          <Grid item xs={12} sx={{ my: '2%' }}>
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, width: '100%' }}>
              <Button
                sx={{ textTransform: 'capitalize' }}
                size='small'
                onClick={() => handleBack()}
                variant="contained" color='secondary'
              >
                Back
              </Button>
              <Button
                sx={{ textTransform: 'capitalize' }}
                size='small'
                onClick={() => proceedForPayment()}
                variant="contained" color="primary"
              >
                Proceed For Payment
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Grid>
      {/* coupon discount section */}
      <Modal
        open={openDiscountModal}
        // onClose={() => setOpenServiceDropdown(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflow: "scroll" }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: { xs: '50%', sm: '50%' },
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            p: 0,
            width: { xs: "95%", sm: "30%" },
            minHeight: '25%'
          }}

          borderRadius={2}
        >
          <Box sx={{ borderBottom: '1px solid lightGray', display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: '1% 2%' }}>
            <Typography sx={{ fontWeight: 600, fontSize: '.9rem' }} >
              Coupon Detail's
            </Typography>
            <IconButton
              size='small'
              onClick={() => setOpenDiscountModal(false)}
              sx={{ p: 0 }}
              color='error'
            >
              <Close sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }} />
            </IconButton>
          </Box>
          <ApplyDiscount setOpenDiscountModal={setOpenDiscountModal}/>
        </Box>
      </Modal>
    </Box >
  );
}
// {
//   "id": 1831,
//   "bookingNumber": "1203252123061831",
//   "customerId": 304,
//   "customerName": "Aniket Singh",
//   "providerId": 238,
//   "providerName": "P7 L7",
//   "paymentId": 1264,
//   "serviceTimeTotal": 2,
//   "subTotal": "249.99",
//   "discount": "0.00",
//   "couponId": 0,
//   "couponAmount": "0.00",
//   "tax": 0,
//   "convenienceFee": 15,
//   "platformCharges": 10,
//   "visitingCharge": 1.99,
//   "b_igst": 0,
//   "b_cgst": 2.25,
//   "b_sgst": 2.25,
//   "b_total_gst": 4.5,
//   "waiveVisitCharge": 2502,
//   "coinValue": 7,
//   "total": 274.48,
//   "startOTP": "576647",
//   "serviceDate": "2025-03-14",
//   "bookingStartTime": "01:30:00",
//   "bookingEndTime": "02:02:00",
//   "serviceStartTime": null,
//   "serviceEndTime": null,
//   "bookingStatus": "inprogress",
//   "callbackRequest": false,
//   "message": "",
//   "comment1": null,
//   "comment2": null,
//   "add_customerFullName": "",
//   "add_mobileNumber": "",
//   "add_pincode": "201301",
//   "add_latitude": "28.615034955438965",
//   "add_longitude": "77.37864252179861",
//   "add_city": "Noida",
//   "add_state": "Uttar Pradesh",
//   "add_landmark": "B-154, Kutumbh Care Pvt Ltd, null",
//   "add_address": "B-154, Kutumbh Care Pvt Ltd, B154, Sector 63, Noida, Uttar Pradesh, 201301, India",
//   "chargeDetails": {
//       "vistingCharge": "1.99",
//       "additionalCharge": "0.00",
//       "cancellationChargeInPercent": 2,
//       "timeLimitForCancellation": 22,
//       "isRefundable": false,
//       "refundableAmount": "0.00",
//       "refundableDuration": 0
//   },
//   "cancelMessage": null,
//   "cancelBy": null,
//   "cancelDate": null,
//   "createdBy": 3,
//   "updateBy": null,
//   "createdAt": "2025-03-12T21:21:27.040Z",
//   "updatedAt": "2025-03-12T21:23:06.701Z",
//   "bookingItems": [
//       {
//           "id": 2358,
//           "serviceBookingId": 1831,
//           "providerServiceId": 484,
//           "serviceName": "Haircut + Shave / Beard Grooming + 10 Mins Massage",
//           "image": "men_grooming-1727287359493.png",
//           "serviceTime": 2,
//           "quantity": 1,
//           "newQuantity": 0,
//           "modifyStatus": "NOTHING",
//           "price": "249.99",
//           "rcm": null,
//           "igst": 0,
//           "cgst": 0,
//           "sgst": 0,
//           "igstNon": 0,
//           "cgstNon": 0,
//           "sgstNon": 0,
//           "tcs": 0,
//           "serviceStatus": "requested",
//           "rejectedReason": null,
//           "createdBy": 3,
//           "updatedBy": null,
//           "createdAt": "2025-03-12T21:21:27.394Z",
//           "updatedAt": "2025-03-12T21:21:27.394Z"
//       }
//   ],
//   "customer": {
//       "id": 304,
//       "mobileNumber": "8899799109",
//       "totalCoin": 60,
//       "profile": {
//           "firstName": "Aniket",
//           "lastName": "Singh"
//       },
//       "defaultAddressDetail": {
//           "city": "Noida",
//           "state": "Uttar Pradesh",
//           "address": "B-154, Kutumbh Care Pvt Ltd, B154, Sector 63, Noida, Uttar Pradesh, 201301, India",
//           "pincode": "201301"
//       }
//   },
//   "provider": {
//       "mobileNumber": "1231231233",
//       "UserProfile": {
//           "firstName": "P7",
//           "lastName": "L7",
//           "waiveVisitCharge": "2502.00",
//           "profileImage": "image-1733303946078.jpg"
//       },
//       "UserAddress": {
//           "address": "B154, Sector 63, Noida, Uttar Pradesh, 201301, India",
//           "city": "Noida",
//           "state": "Uttar Pradesh"
//       },
//       "UserBusinessDetail": {
//           "gstNumber": "10HRIPS3778M1ZU"
//       },
//       "ProviderServices": [
//           {
//               "id": 380,
//               "serviceTime": 1,
//               "price": "501.00",
//               "childService": {
//                   "title": "Men's & Kids' Salon Head, Neck & Shoulder Massage",
//                   "images": "men_massage-1727287402106.jpg"
//               }
//           },
//           {
//               "id": 525,
//               "serviceTime": 2,
//               "price": "9999.00",
//               "childService": {
//                   "title": "Full Body",
//                   "images": "847913ce-ec5d-451d-b90f-ff86bc380605_713x-1740481727516.jpg"
//               }
//           },
//           {
//               "id": 524,
//               "serviceTime": 2,
//               "price": "2500.00",
//               "childService": {
//                   "title": "Arms",
//                   "images": "847913ce-ec5d-451d-b90f-ff86bc380605_713x-1740481561101.jpg"
//               }
//           },
//           {
//               "id": 523,
//               "serviceTime": 2,
//               "price": "1500.00",
//               "childService": {
//                   "title": "Face",
//                   "images": "847913ce-ec5d-451d-b90f-ff86bc380605_713x-1740481516406.jpg"
//               }
//           },
//           {
//               "id": 522,
//               "serviceTime": 2,
//               "price": "70.00",
//               "childService": {
//                   "title": "Kids Haircut",
//                   "images": "hair-cut-1740476435303.jpg"
//               }
//           },
//           {
//               "id": 527,
//               "serviceTime": 30,
//               "price": "250.00",
//               "childService": {
//                   "title": "Men's & Kids' Salon Hair Cut",
//                   "images": "hair_cut_beard_styling-1727287384951.png"
//               }
//           },
//           {
//               "id": 444,
//               "serviceTime": 1,
//               "price": "1001.00",
//               "childService": {
//                   "title": "Windows Laptop Repair",
//                   "images": "laptop_repair-1727288212128.png"
//               }
//           },
//           {
//               "id": 520,
//               "serviceTime": 2,
//               "price": "250.00",
//               "childService": {
//                   "title": "Men's & Kids' Salon Kids Haircut",
//                   "images": ""
//               }
//           },
//           {
//               "id": 414,
//               "serviceTime": 2,
//               "price": "2800.00",
//               "childService": {
//                   "title": "Exterior Painting (per sqft.) w/o Material",
//                   "images": "painter-1733299024596.png"
//               }
//           },
//           {
//               "id": 484,
//               "serviceTime": 2,
//               "price": "249.99",
//               "childService": {
//                   "title": "Haircut + Shave / Beard Grooming + 10 Mins Massage",
//                   "images": "men_grooming-1727287359493.png"
//               }
//           },
//           {
//               "id": 445,
//               "serviceTime": 2,
//               "price": "250000.00",
//               "childService": {
//                   "title": "Advanced Service With Jet",
//                   "images": "ac_repair-1727287955519.png"
//               }
//           }
//       ]
//   },
//   "rating": null,
//   "payment": {
//       "id": 1,
//       "paymentId": "pay_Q12ZRFusswOStn",
//       "prn": null,
//       "orderId": "order_Q12YjQcMWIPGoJ",
//       "transactionNumber": "asdfasdf",
//       "amount": "33.00",
//       "paymentMethod": "UPI",
//       "coins": 0,
//       "wallet": "0.00",
//       "payStatus": "captured",
//       "method": "card",
//       "refund_status": "processed",
//       "amount_refunded": 0,
//       "captured": true,
//       "paymentCreatedDate": "2025-02-28T07:00:47.000Z",
//       "paidAmt": 25280000,
//       "paymentDetails": {
//           "card_id": "card_Q12ZRPn2ZKEZG7",
//           "bank": null,
//           "wallet": null,
//           "vpa": null,
//           "card": {
//               "id": "card_Q12ZRPn2ZKEZG7",
//               "entity": "card",
//               "name": "",
//               "last4": "1111",
//               "network": "Visa",
//               "type": "prepaid",
//               "issuer": null,
//               "international": false,
//               "emi": false,
//               "sub_type": "consumer",
//               "token_iin": null
//           }
//       },
//       "status": "SUCCESS",
//       "createdBy": 1,
//       "updateBy": 1,
//       "createdAt": "2024-09-10T10:32:49.778Z",
//       "updatedAt": "2025-03-05T06:35:40.151Z"
//   },
//   "walletTransactions": null
// }